import React, { useState } from 'react';
import moment from 'moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils from 'react-day-picker/moment';

import TimelineController from '../../controllers/TimelineController';

import { IDayPickerRangeProps } from '../../types/timeline';

import 'react-day-picker/lib/style.css';

const YearMonthForm = ({
  date,
  localeUtils,
  onChange,
}: {
  date: Date;
  localeUtils: MomentLocaleUtils;
  onChange: Function;
}) => {
  const months = localeUtils.getMonths();

  const maxDateRange = TimelineController.initialDateRange;
  const years: Array<number> = [];
  if (maxDateRange.startDate && maxDateRange.endDate) {
    for (let i = maxDateRange.startDate?.year(); i <= moment().year(); i++) {
      years.push(i);
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const month = e.target.form?.month;
    const year = e.target.form?.year;
    onChange(new Date(year.value, month.value));
  };

  return (
    <form className='DayPicker-Caption'>
      <select name='month' onChange={handleChange} value={date.getMonth()}>
        {months.map((month: string, i: number) => (
          <option key={month} value={i}>
            {month}
          </option>
        ))}
      </select>
      <select name='year' onChange={handleChange} value={date.getFullYear()}>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </form>
  );
};

const DayPickerRange = (props: IDayPickerRangeProps) => {
  const { dateRange, maxDateRange, updateDateRange } = props;

  const [startDate, setStartDate] = useState(
    dateRange.startDate ? dateRange.startDate.toDate() : maxDateRange.startDate?.toDate()
  );
  const [endDate, setEndDate] = useState(
    dateRange.endDate ? dateRange.endDate.toDate() : maxDateRange.endDate?.toDate()
  );

  return (
    <React.Fragment>
      <DayPickerInput
        value={dateRange.startDate ? dateRange.startDate.toDate() : maxDateRange.startDate?.toDate()}
        onDayChange={(day) => updateDateRange({ startDate: moment(day), endDate: dateRange.endDate })}
        formatDate={MomentLocaleUtils.formatDate}
        parseDate={MomentLocaleUtils.parseDate}
        keepFocus={false}
        dayPickerProps={{
          fixedWeeks: true,
          month: startDate,
          fromMonth: maxDateRange.startDate?.toDate(),
          toMonth: maxDateRange.endDate?.toDate(),
          disabledDays: [
            {
              after: moment().toDate() || new Date(),
              before: maxDateRange.startDate?.toDate() || new Date(),
            },
          ],
          captionElement: ({ date, localeUtils }) => (
            <YearMonthForm date={date} localeUtils={localeUtils} onChange={(d: Date) => setStartDate(d)} />
          ),
        }}
      />
      <p className='date-separator'>&#8212;</p>
      <DayPickerInput
        value={dateRange.endDate ? dateRange.endDate.toDate() : maxDateRange.endDate?.toDate()}
        onDayChange={(day) => updateDateRange({ startDate: dateRange.startDate, endDate: moment(day) })}
        formatDate={MomentLocaleUtils.formatDate}
        parseDate={MomentLocaleUtils.parseDate}
        keepFocus={false}
        // showOverlay={true}
        dayPickerProps={{
          fixedWeeks: true,
          month: endDate,
          fromMonth: maxDateRange.startDate?.toDate(),
          toMonth: maxDateRange.endDate?.toDate(),
          disabledDays: [
            {
              after: moment().toDate() || new Date(),
              before: maxDateRange.startDate?.toDate() || new Date(),
            },
          ],
          captionElement: ({ date, localeUtils }) => (
            <YearMonthForm date={date} localeUtils={localeUtils} onChange={(d: Date) => setEndDate(d)} />
          ),
        }}
      />
    </React.Fragment>
  );
};

export default DayPickerRange;
